import { Component, OnInit, Input } from '@angular/core';
import { API as AWS_API } from 'aws-amplify';
import { CONST_AWS_API } from '../../../../core/constants';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/core/services/storage.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-default-address',
  templateUrl: './default-address.component.html',
  styleUrls: ['./default-address.component.scss']
})
export class DefaultAddressComponent implements OnInit {

  userInfo: any = {};
  userInfoSubscription: Subscription;
  billingAddressList: any = [];
  shippingAddressList: any = [];
  showShippingForm: boolean = false;
  newShippingAddress: boolean = false;
  newBillingAddress: boolean = false;
  @Input() selectedTickets;
  selectedCardInfoSubscr: Subscription;
  selectedCard: any;
  dispList: any = {};
  prodCountSubscr: Subscription;
  cartProducts: any;
  isFreeTickets: boolean = false;
  cardDisp: boolean = false;
  currentLocation: any;
  @Input('settingsData') settingsData: any = {};
  @Input() currentBlock;
  @Input() organizationId: any;

  constructor(
    private commonSubscribeService: CommanSubscribeService,
    public router: Router,
    private storageService: StorageService,
    private ngxLoader: NgxUiLoaderService
  ) {
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : {};
        } else {
          this.currentLocation = json;
        }
      });
    }
  }

  ngOnInit() {

    if (this.router.url.includes('/stream/') || this.router.url.includes('/album/video/')) {
      this.cardDisp = true;
    }
    
    this.dispList.ship = false;
    this.dispList.billing = false;
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      if (Object.keys(this.userInfo)?.length > 0 && !this.userInfo.is_guest)
        this.getAddress();
    });
    if (this.selectedTickets && this.selectedTickets.length > 0) {
      let freeTick = this.selectedTickets.filter(a => a.ticket_type == 'free');
      if (freeTick.length == this.selectedTickets.length) {
        this.isFreeTickets = true;
      }
      let shippingValue = this.selectedTickets.filter(a => a.shipping_address == 1);
      if (shippingValue.length > 0)
        this.showShippingForm = true;
    }

    this.prodCountSubscr = this.commonSubscribeService.getCartProductsCount().subscribe(response => {
      this.cartProducts = response;
      if (this.cartProducts.length > 0) {
        let digitalProducts = this.cartProducts.filter(a => a.product_info.is_digital);
        this.showShippingForm = (digitalProducts.length != this.cartProducts.length) || (digitalProducts.length == this.cartProducts.length) ? true : false;
        if (Object.keys(this.userInfo)?.length > 0 && !this.userInfo.is_guest)
          this.getAddress();
      }
    });

    this.selectedCardInfoSubscr = this.commonSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
      // if (!response) {
      //   if (Object.keys(this.userInfo)?.length > 0 && !this.userInfo.is_guest)
      //     this.getAddress();
      // }
    });
    if (Object.keys(this.userInfo)?.length > 0 && !this.userInfo.is_guest)
      this.getAddress();
  }

  showList(type) {
    if (type == "shipping") {
      this.dispList.ship = !this.dispList.ship;
    } else if (type == "billing") {
      this.dispList.billing = !this.dispList.billing;
    }
  }

  getAddress() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        organization_id: this.organizationId || this.commonSubscribeService.slugInfo?.organization_id || this.commonSubscribeService.perfomerInfoData?.data?.Data?.[0]?.organization_id || null
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_ADDRESS, data).then(response => {
      this.ngxLoader.stop();
      this.shippingAddressList = []; this.billingAddressList = [];
      this.newShippingAddress = false; this.newBillingAddress = false;
      if (response.data.message === "Success") {
        let addressList = response['data']['Data'];
        if (addressList.length > 0) {
          let shippingAvailable = false, billingAvailable = false;
          addressList.forEach(element => {
            element.defaultShippingAddress = false;
            element.defaultBillingAddress = false;
            if (element.type == "shipping") {
              if (element.default && !shippingAvailable) {
                shippingAvailable = true;
                element.defaultShippingAddress = true;
              }
              this.shippingAddressList.push(element);
            } else if (element.type == "billing") {
              if (element.default && !billingAvailable) {
                billingAvailable = true;
                element.defaultBillingAddress = true;
              }
              this.billingAddressList.push(element);
            }
          });
          const sortByDefaultSAdd = this.shippingAddressList.sort(a => a.defaultShippingAddress ? -1 : 1);
          this.shippingAddressList = sortByDefaultSAdd;
          let shipAdd = this.shippingAddressList;
          this.shippingAddressList = [];
          if((this.currentBlock == "Merch Market" || this.currentBlock =="Tickets") && shipAdd.length > 0){
            shipAdd.forEach(element =>{
              if(element.country_code == this.currentLocation.country_code3)
                this.shippingAddressList.push(element);
            })
            
          }
          const sortByDefaultBAdd = this.billingAddressList.sort(a => a.defaultBillingAddress ? -1 : 1);
          this.billingAddressList = sortByDefaultBAdd;
        }
        let add = {
          billingAddress: this.billingAddressList,
          shippingAddress: this.shippingAddressList
        }
        this.commonSubscribeService.addressListSubject.next(add);
      }
    }).catch(() => {
      this.ngxLoader.stop();
    });
  }

  newAddress(type, from?) {
    let value = type == 'shipping' ? this.shippingAddressList : this.billingAddressList;
    value.forEach(element => {
      if (type == 'shipping') {
        element.shippingAddress = true;
        this.newShippingAddress = true;
        element.defaultShippingAddress = false;
      } else if (type == 'billing') {
        element.billingAddress = true;
        this.newBillingAddress = true;
        element.defaultBillingAddress = false;
      }
    });
    let add = {
      billingAddress: this.billingAddressList,
      shippingAddress: this.shippingAddressList
    }
    this.commonSubscribeService.addressListSubject.next(add);
  }

  selectAddress(type, address) {
    let value = type == 'shipping' ? this.shippingAddressList : this.billingAddressList;
    // Only reset the clicked type's "Add new" state: resetting the other type's flag here unchecked
    // e.g. "Add New Shipping Address" when a billing address was picked, while its form stayed open.
    if (type == 'shipping') this.newShippingAddress = false;
    else if (type == 'billing') this.newBillingAddress = false;
    value.forEach(element => {
      element.defaultShippingAddress = element.shippingAddress = false;
      element.defaultBillingAddress = element.billingAddress = false;
      if (type == 'shipping' && address.id == element.id) {
        element.defaultShippingAddress = true;
        // element.selectedShippingAdd = true;
      } else if (type == 'billing' && address.id == element.id) {
        element.defaultBillingAddress = true;
        // element.selectedBillingAdd = true;
      }
    });
    let add = {
      billingAddress: this.billingAddressList,
      shippingAddress: this.shippingAddressList
    }
    this.commonSubscribeService.addressListSubject.next(add);
  }

  ngOnDestroy() {
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe();
    }
    if (this.prodCountSubscr) {
      this.prodCountSubscr.unsubscribe();
    }
  }

}
